import { getRegion } from 'utils/Region';

function isDominicanaRegion(regionRaw) {
  const region = String(regionRaw || '').trim().toUpperCase();
  return region === 'DOMINICANA' || region === 'REPUBLICA_DOMINICANA' || region === 'REP_DOMINICANA';
}

function formatMonthShort(d) {
  return d
    .toLocaleString('es-DO', { month: 'short' })
    .toUpperCase()
    .replace('.', '');
}

function formatTime24h(d) {
  const hours = String(d.getHours()).padStart(2, '0');
  const mins = String(d.getMinutes()).padStart(2, '0');
  return `${hours}:${mins}`;
}

function formatTime12h(d) {
  // HH:MM AM/PM (as per HU Dominicana)
  return new Intl.DateTimeFormat('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  })
    .format(d)
    .replace(/\s+/g, ' ')
    .trim();
}

/**
 * Formats match time for MatchCard based on region rules.
 *
 * - Dominicana:
 *   - Group/upcoming base: "HH:MM AM/PM / TZ"
 *   - Next stages: "DD MMM – HH:MM AM/PM / TZ"
 * - Default (other regions):
 *   - Group/upcoming base: "HH:MM / TZ"
 *   - Next stages: "DD MMM\nHH:MM / TZ" (keeps existing layout behavior)
 */
export function formatMatchTimeByRegion(
  matchLike,
  { includeDate = false, bracketSingleLine = false } = {},
) {
  if (!matchLike?.scheduledAt) return 'Por definir';
  const d = new Date(matchLike.scheduledAt);
  const tz = matchLike?.timeZoneLabel ?? '';
  const region = getRegion();
  const isDo = isDominicanaRegion(region);

  if (isDo) {
    const time = formatTime12h(d);
    const base = includeDate
      ? `${d.getDate()} ${formatMonthShort(d)} – ${time}`
      : time;
    return `${base}${tz ? ` / ${tz}` : ''}`;
  }

  const time = formatTime24h(d);
  if (!includeDate) {
    return `${time} / ${tz}`;
  }
  const datePart = `${d.getDate()} ${formatMonthShort(d)}`;
  const sep = bracketSingleLine ? ' - ' : '\n';
  return `${datePart}${sep}${time} / ${tz}`;
}

